import { useState } from 'react'

interface ToggleProps {
  on?: boolean
  onChange?: (v: boolean) => void
  disabled?: boolean
  ariaLabel?: string
}

export function Toggle({ on = false, onChange, disabled = false, ariaLabel }: ToggleProps) {
  const [internal, setInternal] = useState(on)
  const value = onChange ? on : internal
  const flip = () => {
    if (disabled) return
    if (onChange) onChange(!on)
    else setInternal(v => !v)
  }
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={flip}
      style={{
        width: 38, height: 22, borderRadius: 999, border: 'none',
        background: value ? 'var(--brand-500)' : 'var(--ink-300)',
        position: 'relative', cursor: disabled ? 'not-allowed' : 'pointer', padding: 0,
        transition: 'background 200ms', flexShrink: 0, opacity: disabled ? 0.7 : 1,
      }}
    >
      <span style={{
        position: 'absolute', top: 2,
        insetInlineStart: value ? 18 : 2,
        width: 18, height: 18, borderRadius: '50%', background: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.18)',
        transition: 'inset-inline-start 200ms',
      }} />
    </button>
  )
}
